import type { IconType } from '@mobi/component-library/Legacy/Icon'

export const unknownWeather = 'weatherUnknown'

export interface WeatherTypes {
  Fine: IconType
  Hot: IconType
  Cloudy: IconType
  Overcast: IconType
  Rainy: IconType
  Raining: IconType
  Storm: IconType
  Showery: IconType
  Awful: IconType
  Snowy: IconType
}

export const WeatherTypes: Record<string, IconType> = {
  Fine: 'weatherFine',
  Hot: 'weatherFine',
  Cloudy: 'weatherCloudy',
  Overcast: 'weatherOvercast',
  Rainy: 'weatherShowery',
  Raining: 'weatherShowery',
  Storm: 'weatherShowery',
  Showery: 'weatherShowery',
  Awful: 'weatherShowery',
  Snowy: 'weatherShowery',
}

export interface IconTypes {
  Races: IconType
  Trots: IconType
  Dogs: IconType
}

export const IconTypes: Record<string, IconType> = {
  Races: 'races',
  Trots: 'trot',
  Dogs: 'dog',
}
